export default "__VITE_ASSET__hqfelYo9__"